import { computed, action, extendObservable } from "mobx";

class AuthStore {
  constructor(routerStore, auth) {
    this.routerStore = routerStore;
    this.auth = auth;

    extendObservable(this, {
      isAuthenticated: false,
      isGettingUser: false,
      error: {
        isVisible: false,
        message: ""
      },
      user: null,
      username: computed(() => (this.user ? this.user.email : null)),
      groups: computed(() => (this.user ? this.user.groups : null)),
      logout: action(async () => {
        this.isAuthenticated = false;
        this.auth.logout("/");
      }),
      checkAuthentication: action(async () => {
        //okta's isAuthenticated only requires an accessToken, we need the idToken for getting the user's information
        const idToken = await this.auth._oktaAuth.tokenManager.get("idToken");
        const isAuthenticated =
          (await this.auth.isAuthenticated()) && idToken !== undefined;
        if (isAuthenticated !== this.isAuthenticated) {
          this.isAuthenticated = isAuthenticated;
        }
      }),
      onSuccess: action(async res => {
        if (res.status === "SUCCESS") {
          /**
           * this.auth.redirect sets the tokens in localStorage
           * However the timing is unpredictable and can be too slow for initial api requests
           * getWithoutPrompt allows us to guarantee that the accessToken is available on initial login.
           */
          const tokens = await this.auth._oktaAuth.token.getWithoutPrompt({
            sessionToken: res.session.token,
            responseType: ["token", "id_token"]
          });
          const [accessToken, idToken] = tokens;
          const accessTokenString = JSON.stringify({ accessToken, idToken });
          window.localStorage.setItem("okta-token-storage", accessTokenString);
          return this.auth.redirect({ sessionToken: res.session.token });
        }
      }),
      onError: action(err => {
        console.log("error logging in", err);
      }),
      getUser: action(async () => {
        this.isGettingUser = true;
        try {
          await this.checkAuthentication();
          this.user = await this.auth.getUser();
          if (this.user && this.isAuthenticated) {
            this.isGettingUser = false;
            return this.user;
          } else if (this.user && !this.isAuthenticated) {
            // access token is not valid, logout and try again
            this.logout();
          }
        } catch (e) {
          //Something went wrong, clear out localStorage to make the user login again
          window.localStorage.clear();
        }
      })
    });
  }
}

export default AuthStore;



// WEBPACK FOOTER //
// ./src/stores/authStore.js